import {
    createBuildCos,
    putObjectToOss,
    uploadFileToOss,
    uploadFilesToOss,
} from "@repo/utils/cos";
import type {
    PutObjectToOssParams,
    STSResponse,
    UploadFileToOssParams,
} from "@repo/utils/cos";
import { appConfig } from "@/config/app-config.ts";
import { UserManager } from "@/service/user-manager";
import { v4 as uuidv4 } from "uuid";

export type { STSResponse, UploadFileToOssParams, PutObjectToOssParams };
export { putObjectToOss, uploadFileToOss, uploadFilesToOss };

/**
 * 构建COS对象
 * @param fileKey 当前上传的文件路径
 */
export const buildCos = createBuildCos({
    buildStsUrl: (scope) => `${appConfig.apiRoot}/user/v2/upload/sts?action=${scope.action}&region=${scope.region}&bucket=${scope.bucket}&prefix=${scope.prefix}`,
    // 必须用 getToken()：webview 历史会话可能把 token 存成纯字符串，
    // getSessionData()?.token 会得到 undefined，STS 无 Authorization，上传会卡在 0%。
    getAuthorizationHeader: () => UserManager.getToken(),
    getReferer: () => window.location.origin,
    getRequestId: () => uuidv4(),
});
